import { API_BASE_PATH } from '@/js/const/index.js';

const apiRequest = (path, method, body, withHeader = false) => {
  let options = {
    method,
    headers: {
      'Accept-Language': window.location.pathname.replace('/', '') || 'en',
    },
  };

  if (body) {
    options = Object.assign({}, options, { body });
  }

  if (withHeader) {
    options = Object.assign({}, options, {
      headers: {
        ...options.headers,
        Authorization: `Bearer ${localStorage.getItem('access_token')}`,
      },
    });
  }

  return fetch(API_BASE_PATH + path, options).then((response) =>
    response.json()
  );
};

export default apiRequest;
